import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PaymentFormModal from "./components/PaymentFormModal";
import PaymentTipsModal from "./components/PaymentTipsModal";
import { checkoutInvoice } from "../../../../../store/checkoutInvoice";
import { usePaymentFlow } from "../../hooks/usePaymentFlow";
import { useInvoice } from "../../hooks/invoice/useInvoice";
import { useInvoiceActions } from "../../hooks/useInvoiceActions";
import { dispatch } from "../../../../../store/store";
import { useAffirmForm } from "./hooks/useAffirmForm";
import { uiNotification } from "../../../../../services/UINotificationService";

const ViewChargeAffirm = ({ history, isTipsApplying }) => {
  const { showTipsModal } = usePaymentFlow();
  const { invoice } = useInvoice();
  const { chargeAffirm } = useInvoiceActions();

  const goToInvoice = () => {
    if (!invoice?.id || !invoice?.patient?.id) return;
    history.push(`/sales/invoice/${invoice.id}/${invoice.patient.id}/invoices`);
  };

  const handlePayment = ({ amount, email, phoneNumber, country }) => {
    chargeAffirm
      .initiate({ amount, email, phoneNumber, country })
      .then((response) => {
        uiNotification.success(response?.data?.message);
        goToInvoice();
      })
      .catch((e) => {
        uiNotification.error(e?.response?.data?.message);
      })
      .finally(() => {
        dispatch(checkoutInvoice.actions.paymentViewClose());
      });
  };

  const form = useAffirmForm({
    showTipsModal,
  });

  return showTipsModal.value ? (
    <PaymentTipsModal
      isTipsApplying={isTipsApplying}
      showTipsModal={showTipsModal}
      handlePayment={handlePayment}
      form={form}
      isLoading={chargeAffirm.isLoading}
    />
  ) : (
    <PaymentFormModal
      isTipsApplying={isTipsApplying}
      form={form}
      isLoading={chargeAffirm.isLoading}
    />
  );
};

const mapStateToProps = (state) => ({
  isTipsApplying: checkoutInvoice.selectors.selectIsTipsApplying(state),
});

export default withRouter(connect(mapStateToProps)(ViewChargeAffirm));
